export class CostReviewElectricalScopeOfWork {
  bomRequired!: number;
  bomDocumentReceived!: number;
  bomProvidedBy!: number;
  writtenSpecificationsAvailable!: number;
  specificationProvider!: number;
  specificationDocumentAvailable!: number;
  ddrKnown!: number;
  engineeringRequired!: number;
  engineeringProvidedBy!: number;
  peStampRequired!: number;
  technicalSolutionReviewed!: number;
}
